var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { OnPremiseProvider } from './on-premise';
var KEY_NAME = 'wheatleyToken';
var WheatleyProvider = /** @class */ (function () {
    function WheatleyProvider(onPremiseProvider) {
        this.onPremiseProvider = onPremiseProvider;
    }
    WheatleyProvider.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var domain, expirationDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.onPremiseProvider.isOnPremiseElectronApp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.onPremiseProvider.setWheatleyToken(token)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        domain = location.host.replace(":" + location.port, '');
                        expirationDate = new Date();
                        expirationDate.setSeconds(expirationDate.getSeconds() + 3600 * 24 * 30);
                        document.cookie = KEY_NAME + "=" + token + "; expires=" + expirationDate.toUTCString() + "; path=/; domain=" + domain + ";";
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WheatleyProvider.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.onPremiseProvider.isOnPremiseElectronApp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.onPremiseProvider.getWheatleyToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, this.getWebCookie(KEY_NAME)];
                }
            });
        });
    };
    WheatleyProvider.prototype.deleteToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var domain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.onPremiseProvider.isOnPremiseElectronApp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.onPremiseProvider.deleteWheatleyToken()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        domain = location.host.replace(":" + location.port, '');
                        document.cookie = KEY_NAME + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + domain + ";";
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the stored value of key from cookie
     *
     * @return string value of the stored key
     */
    WheatleyProvider.prototype.getWebCookie = function (cname) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + cname + "=");
        if (parts && parts.length == 2) {
            var result = parts[parts.length - 1].split(';').shift();
            if (result) {
                return result;
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    };
    WheatleyProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OnPremiseProvider])
    ], WheatleyProvider);
    return WheatleyProvider;
}());
export { WheatleyProvider };
//# sourceMappingURL=wheatley.js.map


// WEBPACK FOOTER //
// ./src/providers/wheatley.ts.pre-build-optimizer.js